
/**
 * 工作流-开始节点
 * zxw
 * 创建时间 2026-03-10
 */

import { winHeight } from '../../incs/FunHelper';
import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Avatar,
    Space,
    Divider,
    Row,
    Col,
    Input,
} from 'antd';
import CNF from '../../incs/Config';

const StartNodeEntity = (props) => {
    const [open, setOpen] = useState(false);

    const cancel = () => {
        setOpen(false);
    }

    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}>
            <Modal
                title={<Space><Avatar size='small' shape='square' icon={props.node.data?.icon} style={{ background: props.node.data?.theme, }} />{props.node.data?.title}</Space>}
                width={480}
                height={winHeight - CNF.menuHeight - CNF.basePadding * 2}
                style={{
                    top: CNF.menuHeight + CNF.basePadding,
                    right: 18,
                    position: 'absolute',
                }}
                mask={false}
                maskClosable={false}
                open={open}
                onCancel={cancel}
                footer={null}
            >
                <Divider />
                <div style={{ height: '100%', }}>
                    <p>预置变量</p>
                    <Row>
                        <Col span={8}>变量名</Col>
                        <Col span={7}>类型</Col>
                        <Col span={9}>描述</Col>
                    </Row>
                    {
                        Object.keys(props.node.data?.input.sys).map((item, index) => (
                            <Row key={index} style={{ marginTop: 5, }}>
                                <Col span={7}>
                                    <Input
                                        value={item}
                                        style={{ width: '100%', }}
                                        disabled={true}
                                    />
                                </Col>
                                <Col span={6} offset={1}>
                                    <Input
                                        value='string'
                                        style={{ width: '100%', }}
                                        disabled={true}
                                    />
                                </Col>
                                <Col span={9} offset={1}>
                                    <Input
                                        value='用户输入的query'
                                        style={{ width: '100%', }}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                        ))
                    }
                </div>
            </Modal>
        </ConfigProvider>
    );
}

export default StartNodeEntity;